// extracted by mini-css-extract-plugin
module.exports = {"container":"TextArea_container__1DNsJ","line_numbers":"TextArea_line_numbers__3XdIp","textarea":"TextArea_textarea__2PzyI"};